import React from "react";
import SecondaryButton from "../Button/SecondaryButton";

const AddItemCard = ({ setOptionSelected = () => {}, type }) => {
  const handleCardClick = () => {
    if (type?.disabled && type?.typeof !== "locked") return;
    setOptionSelected(type?.typeof ?? null);
  };

  return (
    <div
      className={`rounded-lg p-3 border items-center justify-center border-gray-200 dark:border-gray-800 w-full flex gap-3 ${
        type?.disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
      }`}
      key={type?.name}
      onClick={type?.disabled ? undefined : handleCardClick}
    >
      <div className="px-[9px] py-2 border border-gray-200 dark:border-gray-800 rounded-md flex gap-4 items-center justify-center bg-gray-50 dark:bg-gray-800/50">
        {type?.icon}
      </div>
      <div className="flex justify-between items-center w-full">
        <p className="text-sm font-semibold text-gray-800 dark:text-gray-100">{type?.name}</p>
        <SecondaryButton
          title={type?.buttonText}
          textColor="light"
          icon={type?.ButtonIcon}
          onClick={handleCardClick}
          className="w-[85px] shadow-none"
        />
      </div>
    </div>
  );
};

export default AddItemCard;
